module.exports = __webpack_public_path__ + "static/media/graph.8fa81c4a.svg";